import { render, staticRenderFns } from "./NodeConfig.vue?vue&type=template&id=b2c4fd86&scoped=true"
import script from "./NodeConfig.vue?vue&type=script&lang=js"
export * from "./NodeConfig.vue?vue&type=script&lang=js"
import style0 from "./NodeConfig.vue?vue&type=style&index=0&id=b2c4fd86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c4fd86",
  null
  
)

export default component.exports